import { shopManagerApi } from 'configs';
import api from 'configs/api';
import {
  getRPAChargeCodesMappedStart,
  getRPAChargeCodesMappedSuccess,
  getRPAChargeCodesMappedFailed,
  getRPAChargeCodesUnmappedStart,
  getRPAChargeCodesUnmappedSuccess,
  getRPAChargeCodesUnmappedFailed,
  setRPAChargeMappedProductStart,
  setRPAChargeMappedProductSuccess,
  setRPAChargeMappedProductFailed,
  updateRPAChargeMappedProductStart,
  updateRPAChargeMappedProductSuccess,
  updateRPAChargeMappedProductFailed,
  getRPAChargesByCustomerStart,
  getRPAChargesByCustomerSuccess,
  getRPAChargesByCustomerFailed,
  getRPAChargesPatientStatisticsStart,
  getRPAChargesPatientStatisticsSuccess,
  getRPAChargesPatientStatisticsFailed,
} from 'redux/actions/rpa';


const rpaApi = `${shopManagerApi}/rpa`;


export const getRPAChargeCodesMappedApi = async ({
  dispatch,
  sort,
  search,
  filters,
  currentPage,
  rowsPerPage
}) => {
  try {
    dispatch(getRPAChargeCodesMappedStart());
    const sortParams = `${sort.fieldName}=${sort.sortDirection}`;
    const searchParams = (search.searchValue && search.searchField)
      ? `${search.searchField}=${search.searchValue}`
      : '';
    const filterParams = new URLSearchParams(filters).toString();

    const params = `${sortParams}${searchParams ? `&${searchParams}` : ''}&page=${currentPage}&page_size=${rowsPerPage}${filterParams ? `&${filterParams}` : ''}`;

    const { data } = await api.get(`${rpaApi}/chargeCodes/mapped?${params}`);
    dispatch(getRPAChargeCodesMappedSuccess(data));
  } catch (e) {
    dispatch(getRPAChargeCodesMappedFailed(e));
  }
};

export const getRPAChargeCodesUnmappedApi = async ({
  dispatch,
  sort,
  currentPage,
  rowsPerPage
}) => {
  try {
    dispatch(getRPAChargeCodesUnmappedStart());
    const sortParams = `${sort.fieldName}=${sort.sortDirection}`;
    const params = `${sortParams}&page=${currentPage}&page_size=${rowsPerPage}`;
    const { data } = await api.get(`${rpaApi}/chargeCodes/unmapped?${params}`);
    dispatch(getRPAChargeCodesUnmappedSuccess(data));
  } catch (e) {
    dispatch(getRPAChargeCodesUnmappedFailed(e));
  }
};

export const setRPAChargeMappedProductApi = async ({
  dispatch,
  mappedData
}) => {
  try {
    dispatch(setRPAChargeMappedProductStart());
    const { data } = await api.post(`${rpaApi}/products`, mappedData);
    dispatch(setRPAChargeMappedProductSuccess(data));
    return true;
  } catch (e) {
    dispatch(setRPAChargeMappedProductFailed(e));
    return false;
  }
};

export const updateRPAChargeMappedProductApi = async ({
  dispatch,
  id,
  mappedData
}) => {
  try {
    dispatch(updateRPAChargeMappedProductStart());
    const { data } = await api.put(`${rpaApi}/products/${id}`, mappedData);
    dispatch(updateRPAChargeMappedProductSuccess(data));
    return true;
  } catch (e) {
    dispatch(updateRPAChargeMappedProductFailed(e));
    return false;
  }
};

export const getRPAChargesByCustomerApi = async ({
  dispatch,
  email,
  per_page = '20',
  current_page = '1',
  bill_date_sort
}) => {
  const params = new URLSearchParams({
    page: current_page,
    page_size: per_page,
    customer_email: email,
    bill_date_sort
  }).toString();

  try {
    dispatch(getRPAChargesByCustomerStart());
    const { data } = await api.get(`${rpaApi}/charges?${params}`);
    dispatch(getRPAChargesByCustomerSuccess(data));
  } catch (e) {
    dispatch(getRPAChargesByCustomerFailed(e));
  }
};

export const getRPAChargesPatientStatisticsApi = async ({
  dispatch,
  customer_id
}) => {
  try {
    dispatch(getRPAChargesPatientStatisticsStart());
    const { data } = await api.get(`${rpaApi}/patient-statistics?filters%5Bcustomer_id%5D=${customer_id}`);
    dispatch(getRPAChargesPatientStatisticsSuccess(data));
  } catch (e) {
    dispatch(getRPAChargesPatientStatisticsFailed(e));
  }
};
